/**
 * API Configuration utility
 * 
 * In production deployments, the frontend and backend are served from the same host.
 * This utility ensures API calls go to the correct URL regardless of deployment environment.
 */

function getBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // In development or when explicitly set to a preview URL, use the env variable
  if (envUrl && (
    envUrl.includes('localhost') || 
    envUrl.includes('preview.emergentagent.com') ||
    window.location.hostname.includes('preview.emergentagent.com')
  )) {
    return envUrl;
  }
  
  // In production deployments, use the same origin as the frontend
  // This ensures the backend URL matches the deployment URL
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Fallback to env variable
  return envUrl || '';
}

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

export default { BACKEND_URL, API_URL };
